import { api } from '@/lib/api';
import type { RestaurantDetailsRequest, RestaurantDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/restaurant';

export async function save_restaurant_details(
  input: RestaurantDetailsRequest,
): Promise<RestaurantDetailsResponse> {
  const res = await api.post<RestaurantDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_restaurant_details(): Promise<RestaurantDetailsResponse | null> {
  const res = await api.get<RestaurantDetailsResponse | null>(URL);
  return res.data;
}
